import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">热门排行</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            本周播放量最高的热门影片排行，蓝光画质极速观影
          </p>
        </div>
        <div className="space-y-4">
          {rankingData.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 md:gap-6 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300/40 transition-all cursor-pointer group"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl text-lg md:text-xl font-heading flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-400/80 text-background-50' :
                item.rank === 3 ? 'bg-accent-300/70 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="w-12 h-16 md:w-14 md:h-20 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-accent-600 transition-colors truncate">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-400">{item.category}</span>
                  <span className="text-xs text-accent-500 font-semibold">{item.score}分</span>
                </div>
                <p className="text-xs text-foreground-400 mt-0.5 hidden sm:block">{item.heat}</p>
              </div>
              <div className="flex items-center gap-1 text-accent-500 flex-shrink-0">
                <i className="ri-play-circle-line text-lg"></i>
                <span className="text-xs font-medium whitespace-nowrap hidden sm:inline">立即观看</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}